import React, { createContext, useContext, useState } from 'react';
import { Modal } from 'antd';

const ModalContext = createContext();

export function useModal() {
    return useContext(ModalContext);
}

export function ModalProvider({ children }) {
    const [modalContent, setModalContent] = useState(null);
    const [isVisible, setIsVisible] = useState(false);

    const showModal = (content) => {
        setModalContent(content);
        setIsVisible(true);
    };

    const closeModal = () => {
        setIsVisible(false);
        setModalContent(null);
    };

    return (
        <ModalContext.Provider value={{ showModal, closeModal }}>
            {children}
            <Modal
                visible={isVisible}
                onCancel={closeModal}
                footer={null}
                destroyOnClose={true}
            >
                {modalContent}
            </Modal>
        </ModalContext.Provider>
    );
}

